<template>
  <div class="top-nav">
    <div class="nav-img">
      <img v-if="url.indexOf('shian360.com') != -1" src="@/assets/stlogo.png" />
      <img v-else src="@/assets/cqqlogo.png" />
      <!-- <div class="logo-title">食品安全监管平台</div> -->
      <div class="nav-btn">
        <div class="uese-info">
          <el-tooltip content="退出登录" placement="top" v-if="token" class="uese-info">
            <el-button @click="clos()">{{ userName }}</el-button>
          </el-tooltip>
        </div>
        <router-link to="/release" class="issue-btn">
          <el-button type="success" class="all-btn">发布信息</el-button>
        </router-link>
        <router-link to="/register" class="issue-btn" v-if="token == null">
          <el-button type="success" class="all-btn">注册</el-button>
        </router-link>
        <router-link to="/login" class="issue-btn" v-if="token == null">
          <el-button type="success" class="all-btn">登录</el-button>
        </router-link>
      </div>
    </div>
    <div class="nav-info">
      <el-menu class="el-menu-demo">
        <el-menu-item @click="openHonme()">首页</el-menu-item>
        <el-menu-item v-for="item in categroys" :key="item.id" @click="open(item)">{{ item.name }}</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>
<script>
import { proModuleApi } from '@/api/home'
export default {
  name: 'myNav',
  props: {},
  data() {
    return {
      categroys: [],
      id: '',
      text: '我是子组件数据，我要发送给父组件',
      num: 12,
      token: '',
      userName: '',
      url: ''
    }
  },
  created() {
    this.url = window.location.hostname
    this.token = sessionStorage.getItem('token')
    if (this.token) {
      this.userName = '菜圈圈'
    }
    this.getCategoryAll()
  },
  methods: {
    getCategoryAll() {
      proModuleApi
        .getCategory()
        .then(res => {
          if (res.status) {
            this.categroys = res.data
          }
        })
        .catch(err => {})
    },
    openHonme() {
      if (this.$route.path != '/index') {
        this.$router.push({ path: '/index' })
      }
    },
    open(item) {
      let path = this.$route.path
      let name = this.$route.query.name
      if (path == '/index' || path == '/infor') {
        this.$router.push({
          path: '/detail',
          query: {
            id: item.id,
            name: item.name
          }
        })
      }
      if (path == '/detail') {
        if (item.name != name) {
          this.$router.push({
            path: '/detail',
            query: {
              id: item.id,
              name: item.name
            }
          })
          console.log(3)
        }
      }
      window.location.reload()
    },
    clos() {
      window.location.reload()
      sessionStorage.removeItem('token')
    }
  }
}
</script>
<style scoped>
.nav-img {
  /* padding: 20px; */
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
}
.nav-img img {
  width: 400px;
  height: 300px;
  margin-top: -80px;
}
.logo-title {
  /* margin-top: -150px; */
  color: #fc6720;
  float: right;
  position: absolute;
  left: 450px;
  top: 60px;
  font-size: 22px;
}
.nav-btn {
  float: right;
  position: absolute;
  top: 50px;
  right: 450px;
}
.issue-btn {
  float: right;
  margin-top: 15px;
  border: none;
  margin-left: 15px;
}
.all-btn:hover {
  background-color: #107a53;
}
.nav-info {
  background-color: #107a53;
  margin-top: -80px;
}
.el-menu {
  width: 1200px;
  background-color: #107a53;
  border-right: none;
  margin: 0 auto;
}
.el-menu-item {
  display: inline-block;
  color: #fff;
  margin: 0;
  list-style: none;
  padding: 0 100px;
}
.el-menu-item:hover,
.el-menu-item:active {
  background-color: #fc6720;
  color: #fff;
}
.uese-info {
  float: right;
  color: #107a53;
  margin-top: 8px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/myNav.vue